import { render } from "./IconFile.vue?vue&type=template&id=2f67a76c"
const script = {}

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__